<vault-modal title="{{ 'auto_logout.confirm_continue' | translate }}">
  <p>
    {{
      'auto_logout.confirm_continue_message'
        | translate: { timeout: timer | async }
    }}
  </p>
</vault-modal>
